import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import withStyles from '@mui/styles/withStyles';
import Typography from '../../component/Typography';
import Grid from '../../component/form/Grid';
import Paper from '@mui/material/Paper';
import DataTable from '../../component/dataTable/DataTable';
import { onlineOrderListColumns, onlineOrderListFragment } from './OnlineOrdersConstants';
import GatedComponent from '../../component/GatedComponent';
import withTheme from '@mui/styles/withTheme';
import { getMyClient } from '../../apollo';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../component/ErrorFallback';

class OnlineOrders extends Component {
    state = {};

    render() {
        const { classes } = this.props;
        return (
            <div className="online-orders-list">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                            <span>Online Orders</span>
                        </Typography>
                    </Grid>
                </Grid>
                <Paper className={classes.paper} elevation={0}>
                    <div className={classes.wideScroll}>
                        <GatedComponent showComponentCode={'FM_ACCESS_Enquiries'}>
                            {() => this.renderRefereeDoctorTable()}
                        </GatedComponent>
                    </div>
                </Paper>
            </div>
        );
    }

    renderRefereeDoctorTable() {
        return (
            <Fragment>
                <Grid item>
                    <Grid container spacing={3}>
                        <Grid item xs={12} style={{ position: 'relative' }}>
                            <DataTable
                                customClient={getMyClient}
                                dataObject="OnlineOrder"
                                queryName="readOnlineOrders"
                                fragment={onlineOrderListFragment}
                                columns={onlineOrderListColumns}
                                variables={{
                                    limit: 10,
                                    filterBy: [],
                                    filters: [],
                                    sortBy: [
                                        {
                                            field: 'OrderDate',
                                            direction: 'DESC'
                                        }
                                    ]
                                }}
                                brandProperty="LegacyKey"
                                searchVariable="contains"
                                tableTitle="Orders for review"
                                isSortable
                                isFilterable
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

const styles = ({ spacing, typography, palette, funeralHome }) => ({
    paper: {
        padding: spacing(3)
    },
    pageTitle: {
        color: palette.contentForeground[funeralHome]
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.action.active,
        color: palette.text.primary
    },
    wideScroll: {
        overflow: 'visible',
        overflowY: 'auto',
        padding: 12,
        paddingTop: 0,
        paddingLeft: 24,
        marginLeft: -12,
        '& td > div + div': {
            marginTop: 8
        }
    },
    tableData: {
        marginTop: '1rem'
    },
    inline: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },
    dotList: {
        minHeight: 16,
        width: 16,
        display: 'inline-block',
        position: 'absolute',
        left: -18,
        margin: '0 -10px 0 0',
        padding: '0',
        listStyle: 'none',
        '& > :not(:first-child)': {
            marginTop: 2
        }
    },
    dot: {
        height: 16,
        width: 16,
        borderRadius: 16
    },
    icon: {
        fontSize: 16,
        // color: '#26CC6F',
        height: '30px',
        width: '30px'
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    table: {
        '& tbody tr:hover': {
            cursor: 'pointer',
            outline: '3px solid black'
        },
        '& tbody td': {
            padding: 8
        }
    }
});

export default withErrorBoundary(compose(withSnackbarMessage, withTheme, withStyles(styles))(OnlineOrders), {
    fallback: ErrorFallback
});
